/* Recently viewed products — for sections/kt-recently-viewed.liquid. */

(function () {
  const STORAGE_KEY = 'kt:recently-viewed';
  const HISTORY_LIMIT = 20;

  function readHistory() {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!Array.isArray(stored)) return [];
      return stored.filter((handle) => typeof handle === 'string' && handle.length);
    } catch (e) {
      return [];
    }
  }

  function writeHistory(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
    }
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      this.currentHandle = this.dataset.productHandle || null;
      this.limit = parseInt(this.dataset.limit, 10) || 8;
      this.wrapper = this.closest('.kt-product-carousel');

      this.record();

      const handles = this.handlesToShow();
      if (!handles.length) return;

      this.load(handles);
    }

    record() {
      if (!this.currentHandle) return;
      const handles = readHistory().filter((handle) => handle !== this.currentHandle);
      handles.unshift(this.currentHandle);
      writeHistory(handles.slice(0, HISTORY_LIMIT));
    }

    handlesToShow() {
      return readHistory()
        .filter((handle) => handle !== this.currentHandle)
        .slice(0, this.limit);
    }

    load(handles) {
      const url =
        `${this.dataset.url}?section_id=${encodeURIComponent(this.dataset.sectionId)}` +
        `&type=product&q=${encodeURIComponent(handles.join(' '))}`;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const parsed = document.createElement('div');
          parsed.innerHTML = text;

          const fetched = parsed.querySelector('kt-recently-viewed');
          if (!fetched || !fetched.querySelector('[data-product-handle]')) return;

          this.innerHTML = fetched.innerHTML;
          if (this.wrapper) this.wrapper.classList.remove('kt-product-carousel--empty');

          if (typeof DisplayLocalElements === 'function') DisplayLocalElements(this);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  if (!customElements.get('kt-recently-viewed')) {
    customElements.define('kt-recently-viewed', RecentlyViewed);
  }
})();
